/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DatasetPipelineBatchDownloadInput
 */
export interface DatasetPipelineBatchDownloadInput {
  /**
   *
   * @type {boolean}
   * @memberof DatasetPipelineBatchDownloadInput
   */
  includeOriginal: boolean;
  /**
   *
   * @type {Array<number>}
   * @memberof DatasetPipelineBatchDownloadInput
   */
  perturbations?: Array<number>;
}

/**
 * Check if a given object implements the DatasetPipelineBatchDownloadInput interface.
 */
export function instanceOfDatasetPipelineBatchDownloadInput(value: object): value is DatasetPipelineBatchDownloadInput {
  if (!('includeOriginal' in value) || value['includeOriginal'] === undefined) return false;
  return true;
}

export function DatasetPipelineBatchDownloadInputFromJSON(json: any): DatasetPipelineBatchDownloadInput {
  return DatasetPipelineBatchDownloadInputFromJSONTyped(json, false);
}

export function DatasetPipelineBatchDownloadInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DatasetPipelineBatchDownloadInput {
  if (json == null) {
    return json;
  }
  return {
    includeOriginal: json['include_original'],
    perturbations: json['perturbations'] == null ? undefined : json['perturbations'],
  };
}

export function DatasetPipelineBatchDownloadInputToJSON(value?: DatasetPipelineBatchDownloadInput | null): any {
  if (value == null) {
    return value;
  }
  return {
    include_original: value['includeOriginal'],
    perturbations: value['perturbations'],
  };
}
